export const PerPageContentGroup = 10;
